import request from '@/api/request'

// 分页查询企微活码
export const getQwLiveCodeList = (params) => {
  return request({
    url: 'qw/adm/qwLiveCode/getListPage',
    method: 'get',
    params
  })
}

// 获取销售列表
export const getAccList = (params) => {
  return request({
    url: 'qw/adm/qw/qwAccount/getListByPage',
    method: 'get',
    params
  })
}

// 添加企微活码
export const addQwLiveCode = (data) => {
  let url = 'qw/adm/qwLiveCode/addQwLiveCode'
  if (data.id) {
    url = 'qw/adm/qwLiveCode/updateQwLiveCode'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 禁用 & 启用活码
export const toggleStatus = (data) => {
  return request({
    url: 'qw/adm/qwLiveCode/updateStaus',
    method: 'post',
    data
  })
}

// 删除活码
export const delQwLiveCode = (data) => {
  return request({
    url: 'qw/adm/qwLiveCode/delQwLiveCode',
    method: 'post',
    data
  })
}

// 编辑 - 获取活码成员列表
export const getbindAccList = (params) => {
  return request({
    url: 'qw/adm/qwLiveCodeSale/getSaleList',
    method: 'get',
    params
  })
}

// 编辑 - 获取销售权重列表
export const getSaleWeights = (params) => {
  return request({
    url: 'qw/adm/qwLiveCodeSale/getSaleWeights',
    method: 'get',
    params
  })
}

// 获取统计列表
export const getStatisticsList = (params) => {
  return request({
    url: 'qw/adm/qwLiveCodeData/getMemberData',
    method: 'get',
    params
  })
}

// 保存生成的二维码
export const updateCodeUrl = (data) => {
  return request({
    url: 'qw/adm/qwLiveCode/updateCodeUrl',
    method: 'post',
    type: 'json',
    data
  })
}

// 获取统计列表
export const getOauth2Url = () => {
  return request({
    url: 'qw/qwCompanyDetails/getOauth2Url',
    method: 'get'
  })
}

// 获取分组列表
export const getQwClassifyByPid = params => {
  return request({
    url: 'qw/adm/qwClassify/getQwClassifyByPid',
    method: 'get',
    params
  })
}

// 添加分组
export const manageQwClassify = data => {
  let url = 'qw/adm/qwClassify/addQwClassify'
  if (data.id) {
    url = 'qw/adm/qwClassify/updateQwClassify'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 添加分组
export const delQwClassify = data => {
  return request({
    url: 'qw/adm/qwClassify/delQwClassify',
    method: 'post',
    data
  })
}

// 获取活码数量
export const getCodeNum = params => {
  return request({
    url: 'qw/adm/qwClassify/getCodeNum',
    method: 'get',
    params
  })
}

// 获取关联活码数量
export const getRelevenceCodeNum = params => {
  return request({
    url: 'qw/adm/qw/qwAccount/getCodeNum',
    method: 'get',
    params
  })
}

// 批量删除活码联系
export const batchDel = data => {
  return request({
    url: 'qw/adm/qw/qwAccount/batchDel',
    method: 'post',
    data
  })
}

// 删除全部活码联系
export const batchDelAll = data => {
  return request({
    url: 'qw/adm/qw/qwAccount/batchDelAll',
    method: 'post',
    data
  })
}

// 批量添加活码联系
export const batchAdd = data => {
  return request({
    url: 'qw/adm/qw/qwAccount/batchAdd',
    method: 'post',
    data
  })
}

// 添加全部活码联系
export const batchAddAll = data => {
  return request({
    url: 'qw/adm/qw/qwAccount/batchAddAll',
    method: 'post',
    data
  })
}
